import ApiUrls from '@api/apiUrls';
import { fetchApi } from '@api/fetchApi';
import { FeatureFlags, FeatureTypes } from '@api/services/feature/feature.apiService.interfaces';

export const featureService = {
  isEnabled: async (feature: FeatureTypes) => {
    return await fetchApi.get<boolean>(ApiUrls.features.isEnabled, { params: { feature } });
  },
  getAll: async () => {
    return await fetchApi.get<FeatureFlags>(ApiUrls.features.getAll);
  },
};
